import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  userSelectMarketerCustomersName: "userSelectMarketerCustomersName [Action]",
  userSelectMarketerCustomersNameLoading:
    "userSelectMarketerCustomersNameLoading [Action]",
  userSelectMarketerCustomersNameAsync: "userSelectMarketerCustomersNameAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const user_select_marketer_customers_name_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.userSelectMarketerCustomersName:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.userSelectMarketerCustomersNameLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.userSelectMarketerCustomersNameLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "marketer",
    method_type: "user_select_marketer_customers_name",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.userSelectMarketerCustomersName,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.userSelectMarketerCustomersNameLoading,
      payload: false,
    });
  }
}

export function* userSelectMarketerCustomersName() {
  yield takeLatest(actionTypes.userSelectMarketerCustomersNameAsync, handleWorker);
}
